// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"app_footerContent__2EXUU"};